class StoreLocator {
  constructor(config) {
    this.config = {
      containerSelector: '.currentlocation',
      locationMessageSelector: '.modal-location-message',
      checkboxSelector: '.location-checkbox',
      popupSelector: '.open-popup-link',
      optionTitleSelector: '.option-title',
      ...config
    };

    // Parse storeData correctly
    this.storeData = Array.isArray(config.storeData) ? config.storeData : JSON.parse(config.storeData || '[]');
    this.init(); // Initialize the locator
  }

  init() {
    this.initializeMagnificPopup();
    this.initializeDropdowns();
    this.initializeCheckboxes();
    this.getCurrentLocation();
    this.updateLocationDisplay();
  }

  /* getStoreByZipCode + filterCheckboxes removed 2 Jul 2026: the zip-search UI
     was never rendered and the geocode call shipped with a placeholder API key
     (YOUR_GOOGLE_MAPS_API_KEY) — dead code that could never work. */

  initializeMagnificPopup() {
    $(this.config.popupSelector).magnificPopup({
      type: 'inline',
      midClick: true,
      mainClass: 'mfp-fade'
    });
  }

  initializeDropdowns() {
    const options = document.querySelectorAll(this.config.optionTitleSelector);
    options.forEach(option => {
      option.onclick = () => {
        const dropdown = option.nextElementSibling;
        document.querySelectorAll('.dropdown.active').forEach(activeDropdown => {
          if (activeDropdown !== dropdown) {
            activeDropdown.classList.remove('active');
            activeDropdown.style.display = 'none';
          }
        });
        dropdown.classList.toggle('active');
        dropdown.style.display = dropdown.classList.contains('active') ? 'block' : 'none';
      };
    });
  }

  updateAllInstances() {
    const selectedLocations = JSON.parse(localStorage.getItem('selectedLocations') || '[]');
    const nearestLocation = JSON.parse(localStorage.getItem('nearestLocation') || 'null');

    const allSelectors = [
      { container: '.currentlocation', checkboxes: '.location-checkbox', locationMessage: '.modal-location-message' },
      { container: '.currentlocation-mob', checkboxes: '.location-checkbox-mob', locationMessage: '.modal-location-message-mob' }
    ];

    allSelectors.forEach(({ container, checkboxes, locationMessage }) => {
      const displayElement = document.querySelector(container);
      const locationMessageElement = document.querySelector(locationMessage);

      if (displayElement) {
        displayElement.textContent = selectedLocations.length > 0 ? selectedLocations[0] : 'Store Locations';
      }

      const checkboxElements = document.querySelectorAll(checkboxes);
      checkboxElements.forEach(checkbox => {
        checkbox.checked = selectedLocations.includes(checkbox.getAttribute('data-name'));
      });

      if (locationMessageElement && selectedLocations.length === 0) {
        locationMessageElement.style.display = 'block';
        locationMessageElement.textContent = 'Please select a location.';
      }

      if (nearestLocation) {
        const nearestCheckbox = document.querySelector(`${checkboxes}[data-name="${nearestLocation}"]`);
        if (nearestCheckbox) {
          const nearestMessage = document.createElement('span');
          nearestMessage.className = 'nearest-location-message';
          nearestMessage.textContent = 'This is the nearest location';
          // if (!nearestCheckbox.parentElement.querySelector('.nearest-location-message')) {
          //   nearestCheckbox.parentElement.appendChild(nearestMessage);
          // }
        }
      }
    });
  }

  initializeCheckboxes() {
    const checkboxes = document.querySelectorAll(this.config.checkboxSelector);
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        checkboxes.forEach(cb => {
          if (cb !== checkbox) cb.checked = false;
        });

        if (checkbox.checked) {
          const selectedStore = checkbox.getAttribute('data-name');
          localStorage.setItem('selectedLocations', JSON.stringify([selectedStore]));
        }

        this.updateAllInstances();
      });
    });
  }

  getCurrentLocation() {
    const selectedLocations = JSON.parse(localStorage.getItem('selectedLocations') || '[]');

    if (selectedLocations.length > 0) {
      this.updateAllInstances();
      return;
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          this.findClosestStore(position.coords.latitude, position.coords.longitude);
        },
        () => {
          this.selectFirstLocation();
          console.warn('Geolocation failed');
          localStorage.removeItem('nearestLocation');
        }
      );
    } else {
      console.warn('Geolocation is not supported');
      localStorage.removeItem('nearestLocation');
      this.selectFirstLocation();
    }
  }

  findClosestStore(userLat, userLng, sessionUpdate = false) {
    let closestStore = null;
    let minDistance = Infinity;

    this.storeData.forEach(store => {
      const distance = this.calculateDistance(userLat, userLng, store.lat, store.lng);
      if (distance < minDistance) {
        minDistance = distance;
        closestStore = store;
      }
    });

    if (sessionUpdate) {
      return closestStore;
    }

    if (closestStore) {
      const selectedLocations = JSON.parse(localStorage.getItem('selectedLocations') || '[]');
      if (selectedLocations.length === 0) {
        localStorage.setItem('selectedLocations', JSON.stringify([closestStore.name]));
      }
      localStorage.setItem('nearestLocation', JSON.stringify(closestStore.name));
      this.updateAllInstances();
    }
  }

  calculateDistance(lat1, lng1, lat2, lng2) {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLng = ((lng2 - lng1) * Math.PI) / 180;

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);

    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  updateLocationDisplay() {
    const selectedLocations = JSON.parse(localStorage.getItem('selectedLocations') || '[]');
    const displayElement = document.querySelector(this.config.containerSelector);
    if (displayElement) {
      displayElement.textContent = selectedLocations.length > 0 ? selectedLocations[0] : 'Store Locations';
    }

    const checkboxes = document.querySelectorAll(this.config.checkboxSelector);
    checkboxes.forEach(checkbox => {
      checkbox.checked = selectedLocations.includes(checkbox.getAttribute('data-name'));
    });

    const nearestLocation = JSON.parse(localStorage.getItem('nearestLocation'));

    if (nearestLocation) {
      const nearestCheckbox = document.querySelector(`${this.config.checkboxSelector}[data-name="${nearestLocation}"]`);
      if (nearestCheckbox) {
        const nearestMessage = document.createElement('span');
        nearestMessage.className = 'nearest-location-message';
        nearestMessage.textContent = 'This is the nearest location';
        // if (!nearestCheckbox.parentElement.querySelector('.nearest-location-message')) {
        //   nearestCheckbox.parentElement.appendChild(nearestMessage);
        // }
      }
    }
  }

  selectFirstLocation() {
    const checkboxes = document.querySelectorAll(this.config.checkboxSelector);
    if (checkboxes.length > 0) {
      checkboxes.forEach((checkbox, index) => {
        if (index === 0) {
          checkbox.checked = true;
          const selectedStore = checkbox.getAttribute('data-name');
          localStorage.setItem('selectedLocations', JSON.stringify([selectedStore]));
        } else {
          checkbox.checked = false;
        }
      });
      this.updateAllInstances();
    }
  }
}
